import React from 'react'

interface FeatureCheckboxProps {
 label: string
 checked: boolean
 onChange: () => void
 className?: string
}

export const FeatureCheckbox: React.FC<FeatureCheckboxProps> = ({
 label,
 checked,
 onChange,
 className = ''
}) => {
 return (
 <label
 className={`flex items-center space-x-2 cursor-pointer p-2 hover:bg-surface rounded-md transition-colors ${className}`}
 onClick={(e) => {
 e.preventDefault()
 e.stopPropagation()
 onChange()
 }}
 >
 <input
 type="checkbox"
 checked={checked}
 onChange={(e) => {
 e.preventDefault()
 e.stopPropagation()
 }}
 onClick={(e) => {
 e.preventDefault()
 e.stopPropagation()
 }}
 className="h-4 w-4 text-accent focus:ring-accent border-border rounded pointer-events-none"
 />
 <span className="text-sm text-foreground">
 {label}
 </span>
 </label>
 )
}

